// extracted by mini-css-extract-plugin
export default {"container":"_2fIB2x","contentWrapper":"_3H8U5X"};